import {CURRENT_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getBalance: function () {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': `Bearer ${VueCookie.get('token')}`,
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('kpiopenbalances')
  },
  getUsersKPI (department = 1, id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': `Bearer ${VueCookie.get('token')}`,
        'company': VueCookie.get('company')
      }
    })
    const userId = id ? `&userId=${id}` : ''
    const departmentType = `department=${department}`
    const query = `${departmentType}${userId}`
    return instCred.get(`userkpi?${query}`)
  },
  setApprove (uniqueID, body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': `Bearer ${VueCookie.get('token')}`,
        'company': VueCookie.get('company')
      }
    })
    const request = `userkpi/approve/${uniqueID}`
    return instCred.put(request, body)
  },
  getKPIByUser ({userID, column, sort}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': `Bearer ${VueCookie.get('token')}`,
        'company': VueCookie.get('company')
      }
    })
    let request = `userkpi/${userID}?valueType=${column}&sort[]=${sort}`
    return instCred.get(request)
  },
  getKPIChart ({id, startDate, endDate}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': `Bearer ${VueCookie.get('token')}`,
        'company': VueCookie.get('company')
      }
    })
    const request = `userkpi/chart/${id}?startDate=${startDate}&endDate=${endDate}`
    return instCred.get(request)
  },
  openBalance (balance) {
    const body = {
      date: new Date(),
      company: VueCookie.get('company'),
      openBalance: balance
    }
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': `Bearer ${VueCookie.get('token')}`,
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('kpiopenbalances', body)
  },
  getReports: function ({department = 1, limit = 50, page = 1, date}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': `Bearer ${VueCookie.get('token')}`,
        'company': VueCookie.get('company')
      }
    })
    let request = `kpireportexcels?limit=${limit}&page=${page}&department[]=${department}`
    if (date) request += `&date=${date}`
    return instCred.get(request)
  }
}



// WEBPACK FOOTER //
// ./src/api/Kpi/api.js